// Field schemas that drive the generic admin content editor.
// type: text | textarea | url | select | stringlist | metriclist | bool
export const CONTENT_SCHEMAS = {
  faqs: {
    label: "FAQs",
    singular: "FAQ",
    titleField: "q",
    fields: [
      { name: "q", label: "Question", type: "text", required: true },
      { name: "a", label: "Answer", type: "textarea", required: true },
    ],
  },
  products: {
    label: "Products",
    singular: "Product",
    titleField: "name",
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "tag", label: "Category tag", type: "text" },
      { name: "icon", label: "Icon", type: "select", options: ["Receipt", "Users", "Bot", "Workflow", "Server", "LayoutGrid", "Cable", "Wrench", "Gauge", "Sparkles"] },
      { name: "image", label: "Image URL", type: "url" },
      { name: "desc", label: "Short description", type: "textarea" },
      { name: "features", label: "Features (one per line)", type: "stringlist" },
    ],
  },
  testimonials: {
    label: "Testimonials",
    singular: "Testimonial",
    titleField: "name",
    fields: [
      { name: "quote", label: "Quote", type: "textarea", required: true },
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Role / Title", type: "text" },
      { name: "avatar", label: "Avatar image URL", type: "url" },
    ],
  },
  case_studies: {
    label: "Case Studies",
    singular: "Case Study",
    titleField: "title",
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "sector", label: "Sector", type: "text" },
      { name: "image", label: "Image URL", type: "url" },
      { name: "summary", label: "Summary", type: "textarea" },
      { name: "metrics", label: "Outcome metrics", type: "metriclist" },
      { name: "draft", label: "Mark as Draft", type: "bool" },
    ],
  },
};
